module.exports = __WEBPACK_EXTERNAL_MODULE_8__;


/*****************
 ** WEBPACK FOOTER
 ** external {"commonjs":"sinon-chai","commonjs2":"sinon-chai","amd":"sinon-chai"}
 ** module id = 8
 ** module chunks = 0
 **/